import { pdfjs } from 'react-pdf';

// Configure PDF.js worker - use jsdelivr which has version 5.x
pdfjs.GlobalWorkerOptions.workerSrc = `https://cdn.jsdelivr.net/npm/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

console.log('PDF.js version:', pdfjs.version);
console.log('PDF.js worker configured:', pdfjs.GlobalWorkerOptions.workerSrc);

export default pdfjs;
